import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabaseClient';

interface HomepageSection {
  id: string;
  section_key: string;
  title: string | null;
  subtitle: string | null;
  description: string | null;
  description2: string | null;
  badge_text: string | null;
  cta_text: string | null;
  image_url: string | null;
  image_url2: string | null;
  extra_json: unknown;
  is_active: boolean;
}

export const useHomepageSection = (sectionKey: string) => {
  const [data, setData] = useState<HomepageSection | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const { data: row, error } = await supabase
        .from('homepage_sections')
        .select('*')
        .eq('section_key', sectionKey)
        .maybeSingle();
      if (!error && row) setData(row as HomepageSection);
      setLoading(false);
    };
    fetch();
  }, [sectionKey]);

  return { data, loading };
};
